import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQuery } from 'shared/lib/redux';

import { TaughtLesson } from './types';
import { getClassStatsUrl } from './constants';
import { prepareTaughtLessons } from './lib';

export const classStatsApi = createApi({
  reducerPath: 'class-stats',
  baseQuery: baseQuery(getClassStatsUrl),
  refetchOnMountOrArgChange: true,
  endpoints: (builder) => ({
    getTaughtLessons: builder.query<
      TaughtLesson[] | null,
      { classesBks: string[]; offset?: number; limit?: number }
    >({
      query: ({ classesBks, offset, limit }) => {
        // return if there are no selected classes
        if (!classesBks.length) return null;

        const offsetQueryParam = offset ? `&offset=${offset}` : '';
        const limitQueryParam = limit ? `&limit=${limit}` : '';

        return {
          url: `classes/batch-get/events/taught?${offsetQueryParam}${limitQueryParam}`,
          method: 'POST',
          body: classesBks,
        };
      },
      transformResponse: prepareTaughtLessons,
    }),
  }),
});

export const { useGetTaughtLessonsQuery } = classStatsApi;
